import FacturaRecurrenteService from "common/services/FacturaRecurrenteService"
import { LeyAntifraudeConfiguracionRequerida } from "feature-based/features/verifactu/organisms"
import { newDocumentoSelector } from "features/Crear/redux/selectors/newDocumentoSelectors"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { useCallback, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory, useLocation } from "react-router-dom"
import {
  CREAR_FACTURA_RECURRENTE,
  FACTURAS_RECURRENTES,
} from "routes/RoutePaths"
import { globalSelector } from "routes/globalSlice"

import { useCuentaContableEmpresaVenta } from "api/CuentaContableEmpresa.hook"
import { useDownloadFileContext } from "common/context/DownloadFileProvider"
import { TIPO_DOCUMENTO } from "common/utils/documentos"
import NewFacturaRecurrente from "features/Crear/components/NewFacturaRecurrente"
import useFactura from "features/Crear/hooks/useFactura"
import { mapNewFacturaRecurrenteToPost } from "../../mappers/mapNewFacturaRecurrenteToPost"
import { newDocumentoSettingsSelector } from "../../redux/selectors/newDocumentoSettingsSelectors"
import FacturasHeaderAdvertencia from "./FacturasHeaderAdvertencia"

const CreacionFacturaRecurrente = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { cuentasContablesEmpresasRefetch: refreshCuentaVentas } =
    useCuentaContableEmpresaVenta()

  const { pathname } = useLocation()
  const { librador, comesFromMdf, loadingUsuarioExterno } = useFactura()
  const { cuentaContableFactura } = useSelector(newDocumentoSettingsSelector)
  const { tiposImpuestosArticulos, tiposImpuestosGenerales } =
    useSelector(globalSelector)
  const downloadFile = useDownloadFileContext()
  const history = useHistory()
  const totalRetencion = useSelector(
    (state) => state.newDocumento.totalRetencion
  )
  const [observacionCesion, setObservacionCesion] = useState("")
  const [selectedProduct, setSelectedProduct] = useState(true)
  const DOC = useSelector(newDocumentoSelector)

  useEffect(() => {
    setSelectedProduct(pathname === CREAR_FACTURA_RECURRENTE)
  }, [pathname])

  const handleGetPdf = useCallback(
    async (documento: $TSMigrationFixMe) => {
      documento.documentosAsociadosMsg = DOC.documentosAsociadosMsg
      const { data } = await FacturaRecurrenteService.getPdf(
        documento,
        observacionCesion,
        tiposImpuestosArticulos,
        totalRetencion,
        tiposImpuestosGenerales
      )

      downloadFile.handleDownloadPdf("factura-recurrente", data)
    },
    [
      DOC.documentosAsociadosMsg,
      downloadFile,
      observacionCesion,
      tiposImpuestosArticulos,
      totalRetencion,
      tiposImpuestosGenerales,
    ]
  )

  const handleOnCreate = useCallback(
    async (documento: $TSMigrationFixMe) => {
      const facturaRecurrente = await mapNewFacturaRecurrenteToPost(documento)
      await FacturaRecurrenteService.postFactura(
        facturaRecurrente,
        observacionCesion,
        cuentaContableFactura
      )

      refreshCuentaVentas()
    },

    [observacionCesion, cuentaContableFactura, refreshCuentaVentas]
  )
  const handleOnUpdate = useCallback(
    async (documento: $TSMigrationFixMe) => {
      const facturaRecurrente = await mapNewFacturaRecurrenteToPost(documento)
      await FacturaRecurrenteService.editFacturaRecurrente(
        facturaRecurrente,
        observacionCesion,
        cuentaContableFactura
      )

      refreshCuentaVentas()
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [observacionCesion, cuentaContableFactura, dispatch]
  )

  return (
    <>
      <LeyAntifraudeConfiguracionRequerida configurarLeyAntifraudeDefinitivo />
      <div className='scroll'>
        <FacturasHeaderAdvertencia />

        <div className='p-4 content-container'>
          {!loadingUsuarioExterno && (
            <NewFacturaRecurrente
              canEditLibradoLibrador
              librador={librador}
              comesFromMdf={comesFromMdf}
              titleDocumento={t("crear.facturaRec.title")}
              typeDocumento='Factura Recurrente'
              labelSendDocumento={t("crear.facturaRec.sendLabel")}
              onCreate={handleOnCreate}
              getPdf={handleGetPdf}
              tipoDocumento={TIPO_DOCUMENTO.FACTURA}
              observacionCesion={observacionCesion}
              setObservacionCesion={setObservacionCesion}
              redirectOnCreate={() => history.push(FACTURAS_RECURRENTES)}
              onUpdate={handleOnUpdate}
              selectProductos={selectedProduct}
            />
          )}
        </div>
      </div>
    </>
  )
}

export default CreacionFacturaRecurrente
